export const FETCH_TEMPLATE = 'FETCH_TEMPLATE'
export const SEND_TEMPLATE_TEST = 'SEND_TEMPLATE_TEST'
export const SEND_TEMPLATE_ISSUERS = 'SEND_TEMPLATE_ISSUERS'
export const UPDATE_VALUE_TO_SOLVE = 'UPDATE_VALUE_TO_SOLVE'
